/*
 * Created Date: Friday, March 24th 2023
 * Author: Vive Vio Permana
 */

import IconVirtualRoom from "assets/icons/IconVirtualRoom"
import { useTranslation } from "react-i18next"

const SendingAttendanceAlert = () => {

	const { t } = useTranslation();
    
    return <div className="luna-alert-content-container join-room">
        <div className="icon-virtual-room">
            <IconVirtualRoom width={32} height={32}/>
        </div>
        <h5>{t('eventSchedulePage.alert.sendingAttendanceRecord')}</h5>
        <p>{t('eventSchedulePage.alert.sendingAttendanceRecordDescription')}</p>
    </div>
}

export default SendingAttendanceAlert
